export default {
  en: {
    date_short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },

    date_with_day: {
      year: 'numeric', month: 'short', day: 'numeric', weekday: 'short'
    },

    datetime_short: {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
    },

    long: {
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
    },

    form: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },

    time: {
      hour: 'numeric', minute: 'numeric'
    }// must be parsable by moment.js
  },
  'fr': {
    date_short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },

    date_with_day: {
      year: 'numeric', month: 'short', day: 'numeric', weekday: 'short'
    },

    datetime_short: {
      year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
    },

    long: {
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
    },

    form: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },

    time: {
      hour: 'numeric', minute: 'numeric'
    }// must be parsable by moment.js
  }
}
